/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsProjectBase {
    getFixupPrototypeFunction() { return AppSecopsProjectBase.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsProjectBase>): AppSecopsProjectBase {
        let obj = Object.assign(new AppSecopsProjectBase(), model);
        AppSecopsProjectBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsProjectBase>): AppSecopsProjectBase {
        if (!model) return null;
        return AppSecopsProjectBase.newInstance(<AppSecopsProjectBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsProjectBase) {
        if (!obj) return;

        models.AppSecopsProjectBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsProjectBase): boolean {
        Object.setPrototypeOf(obj, AppSecopsProjectBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the application
     */
    name: string;

    /**
     * Project description
     */
    description: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Project related application IDs
     */
    application_ids: Array<string>;

    tags: Array<models.KeyValuePair>;

}
